var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tree',{attrs:{"data":_vm.treeData,"render":_vm.renderContent,"show-checkbox":""},on:{"on-check-change":_vm.selectData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }